import { getSearchParams, adobeData, generateAdobeDataRaceNo } from "@/app/utils/Common";
import { useLanguage, LANGTYPE_EN } from "@/app/utils/LanguageContext";
import { useMyContext } from "@/app/utils/MyContext";
import { menuTabSet } from "@/app/utils/constant/menuTabSet";
import { useEffect, useRef } from "react";
import NewsList from "@/app/ui/Common/NewsList";
import Changes from "./Changes";
import Entries from "./Entries";
import ExpertColumn from "./ExpertColumn";
import FormComment from "./FormComment";
import GeneralInformation from "./GeneralInformation";
import JockeyTrainerRanking from "./JockeyTrainerRanking";
import JockeysRides from "./JockeysRides";
import Loading from "@/app/ui/Common/Loading";
import News from "./News";
import RaceCard from "./RaceCard";
import RaceSummary from "./RaceSummary";
import RacingStatistic from "./RacingStatistic";
import ReferenceOdds from "./ReferenceOdds";
import Results from "./Results";
import TipstersSelection from "./TipstersSelection";
import TrackAnalysis from "./TrackAnalysis";
import TrainersEntries from "./TrainersEntries";

type propType = {
  type?: "mobile" | "pc";
  setRacesDetailLoading: any; 
  isLoadingRacesDetail: any;
  meetings: any;
};

const RenderTabPanel:React.FC<propType> = ({setRacesDetailLoading, isLoadingRacesDetail, meetings, type = "pc"}) => {
  const { state: lang } = useLanguage();
  const { state: myContextState, dispatch: myContextDispatch } = useMyContext();
  const { b_cid } = getSearchParams(new URLSearchParams(window.location.search));
  
  useEffect(() => {
    const countryList = [menuTabSet.RACE_SUMMARY, menuTabSet.RACE_CARD, menuTabSet.EXPERT_COLUMN];
    const authorList = [menuTabSet.EXPERT_COLUMN];
    if(!authorList.includes(myContextState.menuTab?.toString())){  
      const curRace = myContextState.selectedMeeting?.RaceMeetingProfile?.races?.find((r: any) => r.no == myContextState?.selectedRaceNo.valueOf());
         
      adobeData(lang.langType === LANGTYPE_EN ? "en" : "zh-hk", "pageview", {
        pageId: "racing/simulcast",
        raceNo: generateAdobeDataRaceNo(myContextState.selectedMeetingDate, myContextState.selectedMeetingVenueCode, myContextState.selectedRaceNo.valueOf()),
        internalAd: b_cid,
        country: myContextState.selectedMeeting?.countryNameEn || ''
      });
    }
  }, [myContextState.menuTab, myContextState.selectedMeetingDate, myContextState.selectedMeetingVenueCode, myContextState.selectedRaceNo]);

  let render = null;

  switch (myContextState.menuTab?.toString()) {
    case menuTabSet.RACE_SUMMARY:
      render = <><RaceSummary type={type} setRacesDetailLoading={setRacesDetailLoading} isLoadingRacesDetail={isLoadingRacesDetail} meetings={meetings}/><NewsList type={type} meetings={meetings} listtype={"latestNews"} view={"meeting"} /></>;
      break;
    case menuTabSet.REFERENCE_ODDS:
      render = <ReferenceOdds type={type} setRacesDetailLoading={setRacesDetailLoading}/>;
      break;
    case menuTabSet.JOCKEYS_RIDES_FOR_THE_DAY:
      render = <JockeysRides type={type} isLoadingRacesDetail = {isLoadingRacesDetail} setRacesDetailLoading={setRacesDetailLoading}/>;
      break;
    case menuTabSet.TRAINERS_ENTRIES_FOR_THE_DAY:
      render = <TrainersEntries type={type} isLoadingRacesDetail = {isLoadingRacesDetail} setRacesDetailLoading={setRacesDetailLoading}/>;
      break;
    case menuTabSet.ENTRIES:
      render = <Entries type={type} setRacesDetailLoading={setRacesDetailLoading}/>;
      break;
    case menuTabSet.RACE_CARD:
      render = <RaceCard type={type} isLoadingRacesDetail = {isLoadingRacesDetail} setRacesDetailLoading={setRacesDetailLoading}/>;
      break;
    case menuTabSet.NEWS:
      render = <News type={type} setRacesDetailLoading={setRacesDetailLoading}/>;
      break;
    case menuTabSet.RESULTS:
      render = <Results type={type} setRacesDetailLoading={setRacesDetailLoading}/>;
      break; 
    case menuTabSet.JOCKEY_TRAINER_RANKING:
      render = <JockeyTrainerRanking type={type} setRacesDetailLoading={setRacesDetailLoading}/>;
      break;
    case menuTabSet.TRACK_ANALYSIS:
      render = <TrackAnalysis type={type} setRacesDetailLoading={setRacesDetailLoading}/>;
      break;
    case menuTabSet.CHANGES:
      render = <Changes type={type} setRacesDetailLoading={setRacesDetailLoading}/>;
      break;
    case menuTabSet.FORM_COMMENT:
      render = <FormComment setRacesDetailLoading={setRacesDetailLoading}/>;
      break;
    case menuTabSet.EXPERT_COLUMN:
      render = <ExpertColumn type={type} setRacesDetailLoading={setRacesDetailLoading}/>;
      break;
    case menuTabSet.GENERAL_INFORMATION:
      render = <GeneralInformation type={type} setRacesDetailLoading={setRacesDetailLoading}/>;
      break;
    case menuTabSet.TIPSTERS_SELECTION:
      render = <TipstersSelection type={type} setRacesDetailLoading={setRacesDetailLoading}/>;
      break;
    case menuTabSet.RACING_STATISTICS:
      render = <RacingStatistic type={type} setRacesDetailLoading={setRacesDetailLoading}/>;
      break;
  }
  // special handling for presite meeting
  if (myContextState.selectedMeeting?.isPresite()) {
    render = <RaceSummary type={type} meetings={meetings} isLoadingRacesDetail={isLoadingRacesDetail} setRacesDetailLoading={setRacesDetailLoading}/>;
  }

  return <>
    {isLoadingRacesDetail? <Loading />: null}
    <div id="__RenderTabPanel" style={{display: isLoadingRacesDetail? 'none': 'unset'}}>
      {render}
    </div>
  </>;
};

export default RenderTabPanel;